module.exports = __webpack_public_path__ + "media/images/icon__twitter@3x-281326b2c79013c0581f99e9c1dca293.png";